export const DYNAMIC_CLIENT_DIMENSION = {
    CUSTOMER_MOVEMENT_TYPE: 'customer_movement_type',
    CUSTOMER_MOVEMENT_TYPE_DETAILED_KEY: 'customer_movement_type_detailed_key'
};
export const DYNAMIC_CLIENT_DIMENSIONS_CATMAN_KPIS = [
    'customer_movement_type',
    'customer_movement_type_detailed_key',
    'date_key_evolution_date',
    'date_key_evolution_month',
    'date_key_evolution_week',
    'business_brand',
    'business_brand_reduced'
];
export const DYNAMIC_CLIENT_DIMENSIONS_KPI_DISPLAY_NAME = [
    'customer_movement_type',
    'customer_movement_type_detailed_key',
    'date_key_evolution_date',
    'date_key_evolution_month',
    'date_key_evolution_week',
    'business_brand',
    'business_brand_reduced'
];
export const DYNAMIC_CLIENT_DIMENSIONS_KPI_MAPPING = {
    customer_movement_type: 'customer_movement_type',
    customer_movement_type_detailed_key: 'customer_movement_type_detailed_key',
    date_key_evolution_date: 'date_key_evolution_date',
    date_key_evolution_month: 'date_key_evolution_month',
    date_key_evolution_week: 'date_key_evolution_week',
    business_brand: 'business_brand',
    business_brand_reduced: 'business_brand_reduced'
};
export const DYNAMIC_CLIENT_DIMENSIONS_DATA_TABLE_KPI_DISPLAY_NAME = [
    'customer_movement_type',
    'customer_movement_type_detailed_key',
    'date_key_evolution_date',
    'date_key_evolution_month',
    'date_key_evolution_week',
    'business_brand',
    'business_brand_reduced'
];
//# sourceMappingURL=dimensions.kpis.js.map